import { render, staticRenderFns } from "./carDetailHis.vue?vue&type=template&id=cd4ed4a8&scoped=true"
import script from "./carDetailHis.vue?vue&type=script&lang=js"
export * from "./carDetailHis.vue?vue&type=script&lang=js"
import style0 from "./carDetailHis.vue?vue&type=style&index=0&id=cd4ed4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4ed4a8",
  null
  
)

export default component.exports